<template>
  <div class="login-page">
    <div
      class="login-background"
      aria-hidden="true"
    />
    <header class="login-header">
      <button
        type="button"
        :aria-label="$t('loginDesign.back')"
        @click="$router.back()"
      >
        <img
          src="../images/ban6/left.png"
          alt=""
        >
      </button>
      <button
        type="button"
        :aria-label="$t('loginDesign.language')"
        @click="$router.push('/language')"
      >
        <img
          src="../images/ban6/icon_lang.png"
          alt=""
        >
      </button>
    </header>
    <main class="login-content">
      <img
        class="login-logo"
        src="../images/ban6/logo.png"
        alt="Scarlet Nights Club"
      >
      <form
        class="login-form"
        @submit.prevent="submit"
      >
        <h1>{{ $t('loginDesign.title') }}</h1>
        <label class="login-field">
          <img
            src="../images/ban6/user.png"
            alt=""
          >
          <input
            v-model.trim="data.username"
            type="text"
            name="username"
            autocomplete="username"
            :aria-label="$t('loginDesign.username')"
            :placeholder="$t('loginDesign.username')"
          >
        </label>
        <label class="login-field">
          <img
            src="../images/ban6/lock.png"
            alt=""
          >
          <input
            v-model.trim="data.password"
            type="password"
            name="password"
            autocomplete="current-password"
            :aria-label="$t('loginDesign.password')"
            :placeholder="$t('loginDesign.password')"
          >
        </label>
        <button
          class="login-submit"
          type="submit"
          :disabled="submitting"
          :aria-busy="submitting"
        >
          <van-loading
            v-if="submitting"
            size="18px"
            color="currentColor"
          />
          {{ $t(submitting ? 'loginDesign.submitting' : 'loginDesign.submit') }}
        </button>
        <div class="login-links">
          <router-link to="/register">
            {{ $t('loginDesign.register') }}
          </router-link>
       <!--   <router-link to="/index">
            {{ $t('loginDesign.guest') }}
          </router-link> -->
        </div>
      </form>
    </main>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import { Loading } from 'vant';

export default {
  name: 'Login',
  components: { 'van-loading': Loading },
  data() {
    return {
      submitting: false,
      data: { username: '', password: '' },
    };
  },
  created() {
    try {
      localStorage.removeItem('login_password');
      this.data.username = localStorage.getItem('login_username') || '';
    } catch (error) {
      // Storage may be unavailable; the form remains usable without saved preferences.
    }
    this.$parent.footer('user', false);
  },
  methods: {
    async submit() {
      if (this.submitting) return;
      if (!this.data.username) {
        this.$toast(this.$t('loginDesign.username'));
        return;
      }
      if (!this.data.password) {
        this.$toast(this.$t('login.passwordEmpty'));
        return;
      }
      this.submitting = true;
      try {
        const res = await Fetch('/index/login', {
          username: this.data.username,
          password: this.data.password,
        });
        if (!res.data || !res.data.token) {
          this.$toast(this.$t('loginDesign.failed'));
          return;
        }
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('tc', '');
        localStorage.setItem('login_username', this.data.username);
        this.$toast({
          background: '#07c160',
          message: this.$t('login.signInSuccess'),
        });
        await this.$router.replace({ path: this.$route.query.redirect || '/index' });
      } catch (error) {
        // Fetch displays API errors and rejects with an empty string.
        if (error) this.$toast(this.$t('loginDesign.failed'));
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  position: relative;
  isolation: isolate;
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  overflow-x: hidden;
  background: #302d2b;
  color: #eee;
  box-sizing: border-box;
}
.login-background {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)),
    url('../images/ban6/login.jpg') no-repeat left top;
  background-size: auto 100%;
  animation: login-pan 22s linear infinite;
}
@keyframes login-pan {
  0%, 100% { background-position-x: 0%; }
  50% { background-position-x: 100%; }
}
.login-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: calc(10px + env(safe-area-inset-top, 0px)) 10px 0;
  box-sizing: border-box;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 6px;
    border: 0;
    background: transparent;
    cursor: pointer;
  }
  img { width: 20px; height: 20px; object-fit: contain; }
}
.login-content {
  padding-top: ~"max(80px, 10vh)";
  padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
}
.login-logo {
  display: block;
  width: 30%;
  height: auto;
  margin: 0 auto;
}
.login-form {
  width: 87%;
  margin: 0 auto;
  h1 {
    margin: 36px 0 20px;
    color: #eee;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    text-align: center;
  }
}
.login-field {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #b7b2a5;
  border-radius: 7px;
  background: #2c2c2c;
  box-sizing: border-box;
  & + & { margin-top: 22px; }
  &:focus-within { border-color: #f5cda7; }
  img { width: 18px; height: 20px; object-fit: contain; flex-shrink: 0; }
  input {
    min-width: 0;
    width: 100%;
    height: 38px;
    padding: 0 0 0 9px;
    border: 0;
    outline: none;
    border-radius: 0;
    background: transparent;
    color: #eee;
    font-size: 14px;
    text-align: left;
    box-sizing: border-box;
    &::placeholder { color: #a3a3a3; opacity: 1; }
    &:-webkit-autofill {
      -webkit-text-fill-color: #eee;
      box-shadow: 0 0 0 1000px #2c2c2c inset;
    }
  }
}
.login-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  margin-top: 22px;
  padding: 9px 12px;
  border: 0;
  border-radius: 30px;
  background: linear-gradient(#ffe0c2, #eabd92);
  box-shadow: 0 3px 5px rgba(0, 0, 0, .15);
  color: #703825;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  &:disabled { opacity: .7; cursor: wait; }
}
.login-links {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 1.5;
  a { color: #d9b574; max-width: 48%; overflow-wrap: anywhere; }
  a:last-child { text-align: right; }
}
@media (prefers-reduced-motion: reduce) {
  .login-background { animation: none; background-position-x: 50%; }
}
</style>

